import { v4 } from 'uuid'

export const PLAYER_PARTY_ID = v4()
